import SyncIcon from "@mui/icons-material/Sync";
import SyncDisabledIcon from "@mui/icons-material/SyncDisabled";
import { IconButton, ListItem, ListItemText, Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import classNames from "classnames";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    focusedItem: {
      backgroundColor: theme.palette.info.light,
    },
    clickable: {
      cursor: "pointer",
    },
  })
);

export type CardMode = "Link" | "Sync";

export interface DisplayCardProps<T> {
  primaryText: string;
  secondaryElement?: React.ReactNode;
  element: T;
  syncDisabled?: boolean;
  focused?: boolean;
  mode: CardMode;
  onSync?: (element: T) => void;
  className?: string;
  middleElement?: React.ReactNode;
  onClick?: (element: T) => void;
}

const noOp = () => {};

export const DisplayCard = <T,>({
  primaryText,
  secondaryElement,
  element,
  syncDisabled = false,
  focused = false,
  mode,
  onSync = noOp,
  className,
  middleElement = null,
  onClick,
}: DisplayCardProps<T>) => {
  const classes = useStyles();

  const syncAction = (
    <IconButton
      onClick={e => {
        e.stopPropagation();
        onSync(element);
      }}
      size="large"
    >
      {/* TODO: add a tooltip when disabled */}
      {/* (e.g. "Previously synced but feature flag has since been disabled") */}
      {/* TODO: maybe disabled must be checked here at the element level */}
      {syncDisabled ? <SyncDisabledIcon /> : <SyncIcon />}
    </IconButton>
  );

  const actionPicker: Record<CardMode, JSX.Element> = {
    Link: <></>,
    Sync: syncAction,
  };

  return (
    <ListItem
      divider
      className={classNames(className, {
        [classes.focusedItem]: focused,
        [classes.clickable]: !!onClick,
      })}
      onClick={onClick ? () => onClick(element) : undefined}
    >
      <ListItemText primary={primaryText} secondary={secondaryElement} />
      {middleElement}
      {actionPicker[mode]}
    </ListItem>
  );
};
